package com.cybersoftsolution.cybersoftsolutionweb.navigation






        sealed class Screen(val route: String, val slug: String)  {

                object AdminRoot : Screen("/admin","")
                object AdminHome : Screen("/admin/home","home")
                object AdminLogin : Screen("/admin/login","login")
                object AdminCreate : Screen("/admin/create","create")
                object AdminPosts : Screen("/admin/posts","posts")


                object Root : Screen("/","")
        }